import { handleOpenSnackBar } from ".";
import {
  cuiRegex,
  emailRegex,
  partialSkuRegex,
  passwordRegex,
} from "../constants/Variables";

const loginValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  return hasError;
};

const regiterSupplierValidation = (obj, setInputError) => {
  let hasError = false;

  // if (!obj.image) {
  //   setInputError((prev) => ({ ...prev, image: true }));
  //   hasError = true;
  // }

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }
  if (!obj.cui) {
    setInputError((prev) => ({ ...prev, cui: true }));
    hasError = true;
  }
  if (obj.cui && !cuiRegex.test(obj.cui)) {
    setInputError((prev) => ({ ...prev, isCuiValid: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }

  if (!obj.source) {
    setInputError((prev) => ({ ...prev, source: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (obj.password && !passwordRegex.test(obj.password)) {
    setInputError((prev) => ({ ...prev, isPasswordStrong: true }));
    hasError = true;
  }

  if (!obj.license) {
    setInputError((prev) => ({ ...prev, license: true }));
    hasError = true;
  }

  return hasError;
};

const signupValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }

  if (!obj.type) {
    setInputError((prev) => ({ ...prev, type: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  return hasError;
};

const forgotValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  return hasError;
};

const resetValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (!obj.confirmPass) {
    setInputError((prev) => ({ ...prev, confirmPass: true }));
    hasError = true;
  }

  if (obj.password !== obj.confirmPass) {
    setInputError((prev) => ({ ...prev, isPasswordValid: true }));
    hasError = true;
  }

  return hasError;
};

const categoryValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }

  if (!obj.description) {
    setInputError((prev) => ({ ...prev, description: true }));
    hasError = true;
  }

  return hasError;
};

const addProductValidation = (obj, setInputError) => {
  let hasError = false;

  if (obj.image?.length < 2) {
    handleOpenSnackBar(
      "error",
      "At least Two Images are required for the product",
    );
    hasError = true;
  }

  if (!obj.productType) {
    setInputError((prev) => ({ ...prev, productType: true }));
    hasError = true;
  }

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }

  return hasError;
};

const updateSupplierProfileValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (!obj.businessName) {
    setInputError((prev) => ({ ...prev, businessName: true }));
    hasError = true;
  }
  if (!obj.businessEmail) {
    setInputError((prev) => ({ ...prev, businessEmail: true }));
    hasError = true;
  }
  if (obj.businessEmail && !emailRegex.test(obj.businessEmail)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }

  if (!obj.source) {
    setInputError((prev) => ({ ...prev, source: true }));
    hasError = true;
  }

  if (!obj.licenseImg) {
    setInputError((prev) => ({ ...prev, licenseImg: true }));
    hasError = true;
  }

  return hasError;
};

const changePasswordValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.newPassword) {
    setInputError((prev) => ({ ...prev, newPassword: true }));
    hasError = true;
  }

  if (obj.newPassword && !passwordRegex.test(obj.newPassword)) {
    setInputError((prev) => ({ ...prev, isPasswordStrong: true }));
    hasError = true;
  }

  if (!obj.reEnterPassword) {
    setInputError((prev) => ({ ...prev, reEnterPassword: true }));
    hasError = true;
  }

  if (obj.newPassword !== obj.reEnterPassword) {
    setInputError((prev) => ({ ...prev, isPasswordMatch: true }));
    hasError = true;
  }

  if (!obj.oldPassword) {
    setInputError((prev) => ({ ...prev, oldPassword: true }));
    hasError = true;
  }

  return hasError;
};

const updateCompanyProfileValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }

  if (!obj.source) {
    setInputError((prev) => ({ ...prev, source: true }));
    hasError = true;
  }

  if (!obj.licenseImg) {
    setInputError((prev) => ({ ...prev, licenseImg: true }));
    hasError = true;
  }

  return hasError;
};

const regiterWorkerValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (obj.workerBgImages.length < 2) {
    setInputError((prev) => ({ ...prev, workerBgImages: true }));
    hasError = true;
  }
  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.state) {
    setInputError((prev) => ({ ...prev, state: true }));
    hasError = true;
  }

  if (!obj.city) {
    setInputError((prev) => ({ ...prev, city: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }

  if (!obj.expertise) {
    setInputError((prev) => ({ ...prev, expertise: true }));
    hasError = true;
  }

  if (!obj.gender) {
    setInputError((prev) => ({ ...prev, gender: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }

  if (!obj.company) {
    setInputError((prev) => ({ ...prev, company: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (obj.password && !passwordRegex.test(obj.password)) {
    setInputError((prev) => ({ ...prev, isPasswordStrong: true }));
    hasError = true;
  }

  return hasError;
};

const updateWorkerProfileValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (obj.workerBgImages.length < 2) {
    setInputError((prev) => ({ ...prev, workerBgImages: true }));
    hasError = true;
  }
  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.contact.replace("40", "")) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }
  if (!obj.expertise) {
    setInputError((prev) => ({ ...prev, expertise: true }));
    hasError = true;
  }
  if (!obj.gender) {
    setInputError((prev) => ({ ...prev, gender: true }));
    hasError = true;
  }

  if (!obj.country) {
    setInputError((prev) => ({ ...prev, country: true }));
    hasError = true;
  }
  if (!obj.state) {
    setInputError((prev) => ({ ...prev, state: true }));
    hasError = true;
  }
  if (!obj.city) {
    setInputError((prev) => ({ ...prev, city: true }));
    hasError = true;
  }
  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }
  if (!obj.bio) {
    setInputError((prev) => ({ ...prev, bio: true }));
    hasError = true;
  }
  if (obj.bio && obj.bio.length < 150) {
    setInputError((prev) => ({ ...prev, bioGreaterThan50: true }));
    hasError = true;
  }

  return hasError;
};

const registerWorkerValidation = (obj, setInputError, workerDetail) => {
  let hasError = false;

  if (!obj.image) {
    setInputError((prev) => ({ ...prev, image: true }));
    hasError = true;
  }
  if (obj.workerBgImages.length < 2) {
    setInputError((prev) => ({ ...prev, workerBgImages: true }));
    hasError = true;
  }
  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }
  if (!obj.expertise) {
    setInputError((prev) => ({ ...prev, expertise: true }));
    hasError = true;
  }
  // if (!obj.dob) {
  //   setInputError((prev) => ({ ...prev, dob: true }));
  //   hasError = true;
  // }
  if (!obj.gender) {
    setInputError((prev) => ({ ...prev, gender: true }));
    hasError = true;
  }

  if (!workerDetail && !obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (!workerDetail && obj.password && !passwordRegex.test(obj.password)) {
    setInputError((prev) => ({ ...prev, isPasswordStrong: true }));
    hasError = true;
  }

  if (!workerDetail && !obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, confirmPassword: true }));
    hasError = true;
  }

  if (!workerDetail && obj.password !== obj.confirmPassword) {
    setInputError((prev) => ({ ...prev, isPasswordMatch: true }));
    hasError = true;
  }

  return hasError;
};

const addEditProductValidation = (obj, setInputError, errorRef) => {
  const errors = {};

  if (obj.images?.length < 2) {
    errors.images = "validation.uploadAtLeastTwoImages";
  }

  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.productTitleIsRequiredInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-ro");
    }
  } else if (obj.name_ro?.trim()?.length > 250) {
    errors.name_ro = "validation.productTitleIsTooLongInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-ro");
    }
  }

  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.productTitleIsRequiredInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-en");
    }
  } else if (obj.name_en?.trim()?.length > 250) {
    errors.name_en = "validation.productTitleIsTooLongInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-en");
    }
  }

  if (!obj.category) {
    errors.category = "validation.selectCategory";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-category");
    }
  }

  if (obj.category && !obj.subCategory) {
    errors.subCategory = "validation.selectSubCategory";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-sub-category");
    }
  }

  if (obj.category && obj.subCategory && !obj.subSubCategory) {
    errors.subSubCategory = "validation.selectSubSubCategory";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-sub-sub-category");
    }
  }

  if (!obj.solutionType?.length) {
    errors.solutionType = "validation.selectSolutionType";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-solution-type");
    }
  }

  if (obj.productType === "normal") {
    if (!obj.price || isNaN(obj.price)) {
      errors.price = "validation.priceRequired";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-price");
      }
    } else if (obj.price < 0) {
      errors.price = "validation.priceCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-price");
      }
    }

    if (isNaN(obj.profitMargin)) {
      errors.profitMargin = "validation.profitMarginMustBeNumber";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-profit-margin");
      }
    } else if (obj.profitMargin < 0) {
      errors.profitMargin = "validation.profitMarginCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-profit-margin");
      }
    }

    if (isNaN(obj.discount)) {
      errors.discount = "validation.discountMustBeNumber";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-discount");
      }
    } else if (obj.discount < 0) {
      errors.discount = "validation.discountCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-discount");
      }
    }

    if (!obj.quantity || isNaN(obj.quantity)) {
      errors.quantity = "validation.quantityRequired";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-quantity");
      }
    } else if (obj.quantity < 0) {
      errors.quantity = "validation.quantityCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-quantity");
      }
    }

    if (!obj.sku) {
      errors.sku = "validation.skuRequired";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-sku");
      }
    } else if (obj.sku && !partialSkuRegex.test(obj.sku)) {
      errors.sku = "validation.invalidSku";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-sku");
      }
    }
  }

  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.descriptionIsRequiredInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-description-ro");
    }
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.descriptionIsRequiredInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-description-en");
    }
  }

  if (!obj.specification_en?.trim()) {
    errors.specification_en = "validation.specificationIsRequiredInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-specification-en");
    }
  }

  if (!obj.specification_ro?.trim()) {
    errors.specification_ro = "validation.specificationIsRequiredInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-specification-ro");
    }
  }

  setInputError(errors);
  return Object.keys(errors).length === 0;
};

const productInputEnglishValidation = (obj, setInputError, errorRef) => {
  let hasError = false;
  if (!obj.name_en?.trim()) {
    setInputError((prev) => ({ ...prev, name_en: true }));
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-en");
    }
    hasError = true;
  }
  if (!obj.description_en?.trim()) {
    setInputError((prev) => ({ ...prev, description_en: true }));
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-description-en");
    }
    hasError = true;
  }
  return hasError;
};

const addEditPackageValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.name_en?.trim()) {
    setInputError((prev) => ({ ...prev, name_en: true }));
    hasError = true;
  }
  if (!obj.name_ro?.trim()) {
    setInputError((prev) => ({ ...prev, name_ro: true }));
    hasError = true;
  }

  if (!obj.description_en?.trim()) {
    setInputError((prev) => ({ ...prev, description_en: true }));
    hasError = true;
  }
  if (!obj.description_ro?.trim()) {
    setInputError((prev) => ({ ...prev, description_ro: true }));
    hasError = true;
  }

  if (!obj.category) {
    setInputError((prev) => ({ ...prev, category: true }));
    hasError = true;
  }

  if (!obj.quantity) {
    setInputError((prev) => ({ ...prev, quantity: true }));
    hasError = true;
  }

  if (obj.quantity && obj.quantity < 1) {
    setInputError((prev) => ({ ...prev, isValidQuantity: true }));
    hasError = true;
  }

  if (!obj.usageType.length) {
    setInputError((prev) => ({ ...prev, usageType: true }));
    hasError = true;
  }

  if (obj.selectedPackageProduct?.length < 2) {
    setInputError((prev) => ({ ...prev, products: true }));
    hasError = true;
  }

  if (!obj.specification_en?.trim()) {
    setInputError((prev) => ({ ...prev, specification_en: true }));
    hasError = true;
  }
  if (!obj.specification_ro?.trim()) {
    setInputError((prev) => ({ ...prev, specification_ro: true }));
    hasError = true;
  }

  if (!obj.tags || obj.tags.length === 0) {
    setInputError((prev) => ({ ...prev, tags: true }));
    hasError = true;
  }

  return hasError;
};

const registerUserValidation = (obj, setInputError, signupAs) => {
  let hasError = false;

  if (!obj.fname) {
    setInputError((prev) => ({ ...prev, fname: true }));
    hasError = true;
  }
  if (signupAs === "individual" && !obj.lname) {
    setInputError((prev) => ({ ...prev, lname: true }));
    hasError = true;
  }
  if (signupAs === "business" && !obj.cui) {
    setInputError((prev) => ({ ...prev, cui: true }));
    hasError = true;
  }
  if (signupAs === "business" && obj.cui && !cuiRegex.test(obj.cui)) {
    setInputError((prev) => ({ ...prev, isValidCui: true }));
    hasError = true;
  }

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isValidEmail: true }));
    hasError = true;
  }

  if (!obj.contact) {
    setInputError((prev) => ({ ...prev, contact: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  return hasError;
};

const restockProductValidation = (
  obj,
  setInputError,
  isPriceApplied,
  isQuantityApplied,
) => {
  let errors = {};

  if (isQuantityApplied) {
    if (!obj.quantity || isNaN(obj.quantity)) {
      errors.quantity = "validation.quantityRequired";
    } else if (obj.quantity < 0) {
      errors.quantity = "validation.quantityCannotBeNegative";
    }
  }

  if (isPriceApplied) {
    if (!obj.price || isNaN(obj.price)) {
      errors.price = "validation.priceRequired";
    } else if (obj.price < 0) {
      errors.price = "validation.priceCannotBeNegative";
    }

    if (isNaN(obj.profitMargin)) {
      errors.profitMargin = "validation.profitMarginMustBeNumber";
    } else if (obj.profitMargin < 0) {
      errors.profitMargin = "validation.profitMarginCannotBeNegative";
    }

    if (isNaN(obj.discount)) {
      errors.discount = "validation.discountMustBeNumber";
    } else if (obj.discount < 0) {
      errors.discount = "validation.discountCannotBeNegative";
    }
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditBasePackageValidation = (obj, setInputError, errorRef) => {
  let errors = {};

  if (!obj.name_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-name-ro");
    }
    errors.name_ro = "validation.packageNameInRomanianRequired";
  }

  if (!obj.name_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-name-en");
    }
    errors.name_en = "validation.packageNameInEnglishRequired";
  }

  if (!obj.category) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-category");
    }
    errors.category = "validation.categoryRequired";
  }

  if (!obj.solutionType?.length) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-solution-type");
    }
    errors.solutionType = "validation.solutionTypeRequired";
  }

  if (!obj.tags?.length) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-tags");
    }
    errors.tags = "validation.selectAtLeastTwoMatchFit";
  }

  if (!obj.description_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-description-ro");
    }
    errors.description_ro = "validation.packageDescriptionInRomanianRequired";
  }

  if (!obj.description_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-description-en");
    }
    errors.description_en = "validation.packageDescriptionInEnglishRequired";
  }

  if (!obj.specification_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector(
        "#base-package-specification-en",
      );
    }
    errors.specification_en =
      "validation.packageSpecificationInEnglishRequired";
  }
  if (!obj.specification_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector(
        "#base-package-specification-ro",
      );
    }
    errors.specification_ro =
      "validation.packageSpecificationInRomanianRequired";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

export {
  loginValidation,
  regiterSupplierValidation,
  signupValidation,
  forgotValidation,
  resetValidation,
  categoryValidation,
  updateSupplierProfileValidation,
  changePasswordValidation,
  updateCompanyProfileValidation,
  regiterWorkerValidation,
  updateWorkerProfileValidation,
  registerWorkerValidation,
  addEditProductValidation,
  addEditPackageValidation,
  registerUserValidation,
  productInputEnglishValidation,
  restockProductValidation,
  addEditBasePackageValidation,
};
